import React, { useEffect, useState } from "react";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef, IFormItem } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { useMarketingTypeModel } from "../allMemberMarketingTypeModel";
import { noticeService } from "../../../notice/NoticeService";
import { OptionDsType } from "@src/types/FmsTypes";
import { IMdMarketingTypeFields } from "../allMemberMarketingTypeTypes";
import { allMemberMarketingTypeService } from "../allMemberMarketingTypeService";
import { globalPrompt } from "@src/components/YhMessage";
import { useLockFn } from "ahooks";
import { httpRequest } from "@utils/HttpRequest";

export function DetailDrawer() {
	const {
		drawerVisible,
		setDrawerVisible,
		editType,
		marketingTypeDs,
		selectedRow,
		loadData,
	} = useMarketingTypeModel();

	const formRef = React.useRef<IYhFormRef>();
	const [userList, setUserList] = useState<(OptionDsType & { id: string })[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (drawerVisible) {
			loadUserList();
			if (editType === 'edit' || editType === 'look' && selectedRow) {
				formRef.current?.setFieldsValue({
					...selectedRow,
					status: selectedRow.status === 0,
				});
			} else if (editType === 'add') {
				formRef.current?.resetFields();
				formRef.current?.setFieldsValue({
					status: true,
				});
			} else {
				formRef.current?.resetFields();
			}
		}
	}, [drawerVisible, editType, selectedRow]);

	const loadUserList = async () => {
		try {
			const users = await noticeService.findUserAll();
			setUserList(users.filter(e => e.status === 0));
		} catch (error) {
			console.error("加载用户列表失败:", error);
		}
	};

	const onCancel = () => {
		setDrawerVisible(false);
		formRef.current?.resetFields();
	};

	const onSubmit = useLockFn(async () => {
		try {
			const formData = await formRef.current?.validateFields();
			if (formData) {
				setLoading(true);
                let employee = userList?.find(el => el.value === formData.employeeCode);
				const params: IMdMarketingTypeFields = {
					...formData,
					typeCode: formData.typeCode,
					typeName: marketingTypeDs?.find(el => el.value === formData.typeCode)?.label ?? "",
					employeeCode: formData.employeeCode,
					employeeName: employee?.label,
                    employeeId: employee?.id,
					status: formData.status ? 0 : 1,
				};

				let result;
				if (editType === 'add') {
					result = await allMemberMarketingTypeService.insert({
						...params,
						key: '',
					});
				} else {
					result = await allMemberMarketingTypeService.update({
						...params,
						id: selectedRow.id,
					});
				}

				if (result.success) {
					await globalPrompt("message", {
						type: "success",
						text: editType === 'add' ? "新增成功!" : "修改成功!",
					});
					setDrawerVisible(false);
					loadData({ pageNum: 1 });
				} else {
					await globalPrompt("message", {
						type: "error",
						text: (editType === 'add' ? "新增失败!" : "修改失败!") + result.retMsg,
					});
				}
			}
		} catch (error) {
			console.error("提交失败:", error);
		} finally {
			setLoading(false);
		}
	});

	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 4 },
		items: [
			{
				type: FormItemTypeEnum.Select,
				fieldLabel: "营销分类",
				fieldName: "typeCode",
				span: 24,
				ds: marketingTypeDs,
				rules: [{ required: true, message: "请选择营销分类" }],
			},
            
			{
				type: FormItemTypeEnum.Select,
				fieldLabel: "员工",
				fieldName: "employeeCode",
				span: 24,
				ds: userList,
				showSearch: true,
				optionFilterProp: "label",
				filterOption: (input: string, option: any) =>
					String(option?.label ?? "").toLowerCase().includes(String(input ?? "").toLowerCase()),
				rules: [{ required: true, message: "请选择员工" }],
			},
			{
				type: FormItemTypeEnum.Switch,
				fieldLabel: "启用",
				fieldName: "status",
				span: 24,
			},
		] as IFormItem[],
	};

	return (
		<YHDrawer
			title={editType === 'add' ? "新增营销类型" : "编辑营销类型"}
			visible={drawerVisible}
			onCancel={onCancel}
			onOk={onSubmit}
			width={600}
		>
			<YhForm {...formConfig} />
		</YHDrawer>
	);
}
